import { createServerFn } from "@tanstack/react-start";

// GA4 measurement IDs are public by nature; the value lives in the project secret so it can change without code edits.
export const getAnalyticsConfig = createServerFn({ method: "GET" }).handler(async () => {
  const id = (process.env["GOOGLE_ANALYTICS_MEASUREMENT_ID"] ?? "").trim();
  return { measurementId: /^G-[A-Z0-9]+$/.test(id) ? id : null };
});
